var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExternalLinkOutlineIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c.552 0 1 .448 1 1s-.448 1-1 1H6c-.552 0-1 .448-1 1v12l.007.117c.057.497.48.883.993.883h12c.552 0 1-.448 1-1v-6l.007-.117c.057-.497.48-.883.993-.883l.117.007c.497.057.883.48.883.993v6c0 1.657-1.343 3-3 3H6c-1.657 0-3-1.343-3-3V6l.005-.176C3.096 4.249 4.402 3 6 3zm8 0c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1l-.117-.007C19.386 8.936 19 8.513 19 8V6.42l-6.29 6.28-.006.006c-.392.389-1.025.386-1.414-.006l-.003-.003c-.392-.395-.39-1.028.003-1.417L17.58 5H16c-.552 0-1-.448-1-1s.448-1 1-1z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternalLinkOutlineIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/externalLinkOutlineIcon.dc5940dc.svg";
export { ForwardRef as ReactComponent };